import { render, staticRenderFns } from "./InfopointLayouts.vue?vue&type=template&id=fb1bf9a8&scoped=true"
import script from "./InfopointLayouts.vue?vue&type=script&lang=js"
export * from "./InfopointLayouts.vue?vue&type=script&lang=js"
import style0 from "./InfopointLayouts.vue?vue&type=style&index=0&id=fb1bf9a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1bf9a8",
  null
  
)

export default component.exports